// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3uV9S","disabled":"FileBtn_disabled__2qfhK","warn":"FileBtn_warn__11b5Z","fade":"FileBtn_fade__2MOYQ"};